import { useState,useEffect } from "react"
import { useNavigate } from "react-router-dom"
import axios from 'axios'
import ic_user from "../Img/ic_user.png"
export default function DatosUsuario({usuario,setUsuario,setPerfilArriba}){
    const navigate=useNavigate()
    const [perfil,setPerfil] = useState(usuario!=null && usuario.perfil!=null?usuario.perfil:null)
    useEffect(()=>{
        if (usuario!=null){
            axios.get(`https://www.asinova.es/webapi/api/Usuarios/${usuario.id}`)
                .then(res=>{
                    setPerfil(res.data.perfil!=null?res.data.perfil:null)
                    setPerfilArriba(res.data.perfil!=null?res.data.perfil:null)
            })
            .catch(error=>{
                localStorage.removeItem("log")
                navigate('/iniciar-sesion')
            })
        }
        else{
            navigate("/iniciar-sesion")
        }
    },[perfil])
    const ChangeImage=async (event)=>{
        const file = event.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append("imagen", file);
        try {
            await axios.put(`https://www.asinova.es/webapi/api/Usuarios/${usuario.id}/Perfil`,formData)
            axios.get(`https://www.asinova.es/webapi/api/Usuarios/${usuario.id}`)
                .then(res=>{
                    setUsuario(res.data)
                    setPerfil(res.data.perfil)
                    setPerfilArriba(res.data.perfil)
                })
        } catch (error) {
            console.error("Error al subir la imagen", error);
        }
    }
    return (
        <>
            {usuario!=null?
                <>
                    <h1 className="mt0" style={{textAlign:'center'}}>DATOS DE USUARIO</h1>
                    {perfil!=null ? <img src={`data:image/*;base64,${perfil}`} style={{width:'192px',height:'192px',borderRadius:'50%',margin:'0 auto'}}></img> : <img src={ic_user} style={{width:'192px',borderRadius:'50%',margin:'0 auto'}}/>}
                    <div className="formulario-vertical" style={{margin:'1rem auto'}}>
                        <input type="file" accept="image/*" onChange={ChangeImage} className="input-image" style={{fontSize:'1rem'}}/>
                    </div>
                    <table style={{width:'fit-content',margin:'0 auto'}} className="th-lateral">
                        <tr><td>Nombre</td><td>{usuario.nombre}</td></tr>
                        <tr><td>Apellidos</td><td>{usuario.apellido1} {usuario.apellido2}</td></tr>
                        <tr><td>Nick</td><td>{usuario.nick}</td></tr>
                        <tr><td>Email</td><td>{usuario.email}</td></tr>
                        <tr><td>Teléfono</td><td>{usuario.telefono}</td></tr>
                        <tr><td>Administrador</td><td>{usuario.administrador?"Sí":"No"}</td></tr>
                    </table>
                </>
                :null
            }
        </>
    )
}